export const objectToCsv = function (data: any[]) {
  const csvRows = [];
  const headers = Object.keys(data[0]);
  csvRows.push(headers.map((key) => `"${key}"`).join(','));
  for (const row of data) {
    const values = headers.map((header) => `"${row[header]}"`);
    csvRows.push(values.join(','));
  }
  return csvRows.join('\n');
};
